const link = {
  wordBreak: 'break-all',
}

export const styles = {
  link,
}
